import { graphql } from '~/gql'

const DISTRIBUTOR_USAGE_REPORT_QUERY = graphql(`
  query DistributorUsageReportQuery($filter: ReportFilter) {
    distributorUsageReport(filter: $filter) {
      reports {
        email
        company
        yearToDate
        last30Days
      }
    }
  }
`)

export default DISTRIBUTOR_USAGE_REPORT_QUERY
